// features/exampleSlice.js
import { createSlice } from '@reduxjs/toolkit';

const toolbarSlice = createSlice({
  name: 'toolbar',
  initialState: {
    tool: 'select',
  },
  reducers: {
    setTool: (state, action) => {
      state.tool = action.payload;
    },
  },
});

export const { setTool } = toolbarSlice.actions;
export default toolbarSlice.reducer;
